<div style="padding: 30px">
    <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
        <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
            <span [ngClass]="now == item.id ? 'active' : ''" class="nav-link" href="#">{{item.name}}</span>
        </li>
    </ul>

    <div *ngIf="now=='1' || now ==  '5'|| now ==  '8' || now == '11'">
        <div *ngFor="let item of info;let i = index" class="card text-white bg-light mb-3 info_item">
            <div class="card-header">{{item.header}}</div>
            <div class="card-body">
                <p class="card-text">儲值成功金額：<span>{{item.success|number}}</span></p>
                <p class="card-text">儲值失敗金額：<span>{{item.fail|number}}</span></p>
                <p class="card-text">處理中金額：<span>{{item.check|number}}</span></p>
                <p class="card-text">退款金額：<span>{{item.return|number}}</span></p>
                <p class="card-text">得到鑽石數：<span>{{item.diamond|number}}</span></p>
            </div>
        </div>
    </div>

    <div class="d-flex flex-wrap align-items-center" *ngIf="now=='1' || now == '5'|| now == '8' || now == '11'">
        <app-date class="mx-1" [type] = "true" [timeset] = "timeset" [time] = "time"  (rangeSelected)="handleRangeSelected($event, 1)"></app-date>
        <select class="form-control mx-1"
            *ngIf = "now=='1'"
            style = "width: 160px; display: inline-block;"
            [(ngModel)] = "type_model"
            (change) = "init_list()"
        >
            <option *ngFor="let item of type_option" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <select class="form-control mx-1"
            *ngIf="now=='1'"
            style="width: 160px; display: inline-block;"
            [(ngModel)]="status_model"
            (change)="init_list()"
        >
            <option *ngFor="let item of status_option" [ngValue]="item.id">{{item.name}}</option>
        </select>

        <select class="form-control mx-1"
            *ngIf="now=='1'"
            style="width: 160px;display: inline-block;"
            [(ngModel)]="check_model"
            (change)="init_list()"
        >
            <option *ngFor="let item of check_option" [ngValue]="item.id">{{item.name}}</option>
        </select>
        
        <div class="multi-select-wrap mx-1" *ngIf="now == '8' || now == '11'">
            <div class="form-control multi-select-toggle" style="width: 200px; cursor: pointer; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;" (click)="toggleTradeStatusDropdown()">
                {{selectedTradeStatusLabel}}
                <span style="float:right">&#9662;</span>
            </div>
            <div class="multi-select-dropdown" *ngIf="trade_status_open">
                <label *ngFor="let item of trade_status_option" class="multi-select-item">
                    <input type="checkbox" [(ngModel)]="item.checked" (change)="onTradeStatusChange()">
                    <span>{{item.id}}：{{item.name}}</span>
                </label>
            </div>
        </div>

        <input (keyup.enter)="init_list()" type="text" [(ngModel)]="search_model" style="width: 220px; display:inline-block" class="form-control mx-1" placeholder="姓名 / 手機 / UID / 訂單號">

        <button class="btn btn-primary mx-1"  (click)="init_list()">確認</button>
    </div>

    <div *ngIf="now=='9'">
        <app-date [time]="time" [type]="true" [timeset]="timeset" (rangeSelected)="handleRangeSelected($event, 2)"></app-date>
        <select class="form-control mx-1"
            style="width: 160px;display: inline-block;margin:10px"
            [(ngModel)]="country_model"
            (change)="choose('9')"
        >
            <option *ngFor="let item of country_list" [ngValue]="item.id">{{item.name}}</option>
        </select>
        <h4 style="margin: 10px;">區間總金額:{{all_money|number}}元</h4>
        <h4 style="margin: 10px;">區間人數:{{all_people|number}}人</h4>
        <h4 style="margin: 10px;">平均貢獻:{{avg_profit|number}}元</h4>
        <div class="pie" >
            <highcharts-chart *ngIf="country_model=='all'" class="son_pie" [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions" ></highcharts-chart>
            <highcharts-chart class="son_pie" [Highcharts]="Highcharts"  [(update)]="updateFlag" [options]="pieOptions2"></highcharts-chart>
        </div>
    </div>

    <!-- 首儲紀錄區域 -->
    <div *ngIf="now == '10'">
        <div class="alert alert-info">
            <p class="my-2"><strong>📍 用戶資格確認時間點：</strong> 每小時 07 分</p>
            <p class="my-2"><strong>📍 系統派獎時間：</strong> 每周一凌晨 12:30</p>
        </div>

        <!-- 使用 d-flex 讓輸入框和選擇框同一行，並透過 me-2 調整間距 -->
        <div class="d-flex flex-wrap align-items-center gap-2 mb-3">
            <span class="pr-2 d-flex align-items-center">🔎查詢: </span>
            <input
                (keyup.enter)="firstdeposit_list()"
                type="text"
                [(ngModel)]="firstdeposit_search_model"
                class="form-control flex-grow-1 mr-2"
                placeholder="輸入電話或暱稱"
                style="max-width: 250px;"
            />
            <span class="ml-2 pr-2 d-flex align-items-center">指定查詢性別: </span>
            <select class="form-control mr-2" [(ngModel)]="firstdeposit_gender_model" (change)="firstdeposit_list()" style="max-width: 150px;">
                <option value="0">全部</option>
                <option value="1">男生</option>
                <option value="2">女生</option>
            </select>

            <span class="ml-2 pr-2 d-flex align-items-center"> 🗳️派獎狀態: </span>
            <select class="form-control" [(ngModel)]="firstdeposit_status_selected" (change)="firstdeposit_list()" style="max-width: 180px;">
                <option *ngFor="let s of firstdeposit_status_option" [value]="s.id">{{s.name}}</option>
            </select>

            <!-- 日期查詢功能 -->
            <span class="ml-3 pr-2 d-flex align-items-center"> 📆首消日期範圍: </span>
            <app-date [type]="true" [timeset]="timeset" [time]="firstdeposit_time"  (rangeSelected)="firstDepositHandleRangeSelected($event)" (showDatePickered)="firstDepositShowDatePickered()"></app-date>
        </div>

        <app-table-v2 *ngIf="now=='10'" [data]="firstDeposit_data" [tcontent]="tcontent" [type]="2">
            <ng-template let-post #operation_dk>
                <div *ngIf="post.key == 'create_dt'">
                    {{post.val.create_dt}}
                </div>
            </ng-template>
        </app-table-v2>
        <!-- 分頁組件 -->
        <app-pagnation (callback)="firstDeposit_callback($event)" [data]="firstDepositPageStr"></app-pagnation>
    </div>

    <app-table-v2  *ngIf="now=='1' || now == '8' || now == '11' || now == '5'" [type]="2" [tcontent]="tcontent" [data]="data"  [custom]="custom" (link) = "handleClick($event)">
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'usa_create_dt'">
                <span [innerHtml]="post.val.usa_create_dt"></span>
            </div>
            <div *ngIf="post.key == 'operation'">
                <a *ngIf="post.val.status == 0" title="點我重驗證(僅未付款可操作)" style="cursor: pointer;" (click)="handleClick(post.val)">
                    <i style="margin-right:10px" class="fas fa-redo-alt"></i>
                </a>
                <a *ngIf="post.val.status != 0" title="僅未付款(0)狀態可操作" style="cursor: not-allowed; color: #ccc;">
                    <i style="margin-right:10px" class="fas fa-redo-alt"></i>
                </a>
            </div>
        </ng-template>
    </app-table-v2>

    <app-pagnation *ngIf="now=='1' || now == '8' || now == '11' || now == '5'" (callback)="callback($event)"  [data]="pageobjstr"></app-pagnation>

    <div *ngIf="now=='2' && !loading">
        <div *ngFor="let y of years; let i = index">
            <div>{{ y }}年</div>
            <highcharts-chart
                [Highcharts]="Highcharts"
                [(update)]="updateFlag"
                [options]="[barOptions3, barOptions2, barOptions][i]"
                style="display:block;width:70%;margin:10px">
            </highcharts-chart>
        </div>
    </div>
    <div *ngIf="now=='3' && !loading">
        <div *ngFor="let y of years; let i = index">
            <div>{{ y }}年</div>
            <highcharts-chart
                [Highcharts]="Highcharts"
                [(update)]="updateFlag"
                [options]="[barOptions3, barOptions2, barOptions][i]"
                style="display:block;width:70%;margin:10px">
            </highcharts-chart>
        </div>
    </div>
    <div *ngIf="now=='4' && !loading">
        <div *ngFor="let y of years; let i = index">
            <div>{{ y }}年</div>
            <highcharts-chart
                [Highcharts]="Highcharts"
                [(update)]="updateFlag"
                [options]="[barOptions3, barOptions2, barOptions][i]"
                style="display:block;width:70%;margin:10px">
            </highcharts-chart>
        </div>
    </div>
    <div *ngIf="now=='6' && !loading">
        <div *ngFor="let y of years; let i = index">
            <div>{{ y }}年</div>
            <highcharts-chart
                [Highcharts]="Highcharts"
                [(update)]="updateFlag"
                [options]="[barOptions3, barOptions2, barOptions][i]"
                style="display:block;width:70%;margin:10px">
            </highcharts-chart>
        </div>
    </div>
    <div *ngIf="now=='7' && !loading">
        <div *ngFor="let y of years; let i = index">
            <div>{{ y }}年</div>
            <highcharts-chart
                [Highcharts]="Highcharts"
                [(update)]="updateFlag"
                [options]="[barOptions3, barOptions2, barOptions][i]"
                style="display:block;width:70%;margin:10px">
            </highcharts-chart>
        </div>
    </div>
    <app-spinner [loading]="loading"></app-spinner>
</div>
